import React from "react";
import SmartLink from "components/SmartLink"; // Neu importieren, falls cta genutzt wird
import SectionWrapper from "components/elements/SectionWrapper";
import styles from "./GallerySection.module.scss";

const GallerySection = (props) => {
  // Erweitert um optionale Props: title, cta_text, cta_link
  const { alignment, data, cta_text, cta_link } = props;
  const alignmentClass = alignment ? `justify-content-${alignment}` : "";
  return (
    <div className={`text-${alignment ? alignment : "left"}`}>
      <SectionWrapper className={`${styles.GallerySection}`} fluid={false} {...props}>
        <div className={`row ${alignmentClass}`}>
          {data && data.map((item, index) => (
            <div className="col-sm-6 col-lg-3 mb-4" key={index}>
              <img src={item.mediaUrl} alt={item.alt_text} className="img-fluid rounded" />
            </div>
          ))}
        </div>
        {cta_text && cta_link && (
          <SmartLink to={cta_link} className="btn btn-primary mt-3">
            {cta_text}
          </SmartLink>
        )}
      </SectionWrapper>
    </div>
  );
};

export default GallerySection;